__turbopack_context__.v({
  "contents": "BlockTablesContent-module-scss-module__-B5vjG__contents",
  "hasScroll": "BlockTablesContent-module-scss-module__-B5vjG__hasScroll",
  "hasScrolled": "BlockTablesContent-module-scss-module__-B5vjG__hasScrolled",
  "lastRow": "BlockTablesContent-module-scss-module__-B5vjG__lastRow",
  "outerContents": "BlockTablesContent-module-scss-module__-B5vjG__outerContents",
  "scrollRightButton": "BlockTablesContent-module-scss-module__-B5vjG__scrollRightButton",
  "secondLastRow": "BlockTablesContent-module-scss-module__-B5vjG__secondLastRow",
});
